import {EquipmentScoreType} from '../../../../../types/MarketType';
import type {MostSearchedEquipmentItem} from '../types/MostSearchedEquipmentItem';
import {getEquipmentFeaturePresenceMap} from './getEquipmentFeaturePresenceMap';
import {getMostSearchedFeatureDefinitions} from './getMostSearchedFeatureDefinitions';

export function getMostSearchedEquipmentItems(
  equipmentScore: EquipmentScoreType | undefined
): MostSearchedEquipmentItem[] {
  const presenceMap = getEquipmentFeaturePresenceMap(equipmentScore);
  return getMostSearchedFeatureDefinitions().map((featureDefinition) => ({
    ...featureDefinition,
    isAvailable: !!presenceMap[featureDefinition.featureCode],
  }));
}
